import { useTranslations } from "next-intl";
import { useCancelSuspension } from "@hooks/use-subscription";
import Button from "@components/core/Button";
import Image from "@components/core/Image";
import { showSuccessToast, showWarningToast } from "@utils/toasts/showToasts";

function SubscriptionCancelationAlreadyAsked() {
  const t = useTranslations("accounts");

  const cancelSuspension = useCancelSuspension();

  async function restartNow() {
    try {
      await cancelSuspension();
      showSuccessToast(
        t(
          "manage_subscription.cancelation.already_asked.suspension_request_canceled.title",
        ),
        t(
          "manage_subscription.cancelation.already_asked.suspension_request_canceled.description",
        ),
      );
    } catch (err) {
      showWarningToast(
        t(
          "manage_subscription.cancelation.already_asked.suspension_request_canceled_error.title",
        ),
        t(
          "manage_subscription.cancelation.already_asked.suspension_request_canceled_error.description",
        ),
      );
    }
  }

  return (
    <div
      data-testid="manage-subscription-cancelation-asked-section"
      style={{ maxWidth: "50%" }}
      className="manage-subscription-card"
    >
      <div className="manage-subscription-card-content">
        <div className="p-3 d-flex flex-column align-items-center">
          <h5 className="text-center mb-0">
            {t("manage_subscription.cancelation.already_asked.title")}
          </h5>

          <div
            className="my-5"
            style={{ width: "128px" }}
          >
            <Image
              src="handbagHappyNeon"
              alt={t("manage_subscription.cancelation.alt_happy")}
              className="w-100"
            />
          </div>

          <p className="text-center mb-0">
            {t("manage_subscription.cancelation.already_asked.description")}
          </p>
        </div>

        <div className="p-2 d-flex justify-content-center border-top">
          <Button
            variant="ghost-primary"
            onClick={restartNow}
          >
            {t("manage_subscription.cancelation.already_asked.restart_now")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionCancelationAlreadyAsked;
